export const DEFAULT_POINTS_PER_STATEMENT = 7;
export const DEFAULT_SCALE_RANGE_FOR_SLIDER = 10;
export const API_URL = '/survey_tsn/questionnaire';